import BookService from "@/core/services/library/book/BookService";
import ShelfService from "@/core/services/library/shelf/ShelfService";
import LibraryShelfRackService from "@/core/services/library/shelf/LibraryShelfRackService";
import DeweyDecimalClassService from "@/core/services/library/dewey-decimal-class/DeweyDecimalClassService";
import IssueService from "@/core/services/library/issue/IssueService";
import SiteSettingService from "@/core/services/site-setting/SiteSettingService";
import BookAccessionService from "@/core/services/library/book/BookAccessionService";
import SettingService from "@/core/services/library/setting/SettingService";
import userService from "@/core/services/user/UserService";

const user = new userService();
const rackService = new LibraryShelfRackService();
const shelfService = new ShelfService();
const classService = new DeweyDecimalClassService();
const issueService = new IssueService();
const bookService = new BookService();
const siteSetting = new SiteSettingService();
const accession = new BookAccessionService();
const setting = new SettingService();

export default {
    data() {
        return {
            names: {
                books: [],
                authors: [],
                editors: [],
                publishers: [],
                publications: [],
            },
            book_barcode_no: null,
            exist: false,
            isBusy: false,
            shelves: [],
            racks: [],
            classifications: [],
            child_classifications: [],
            accessions: [],
            active_books: [],
            books: [],
            user_issue_list: [],
            book_availability: false,
            library_setting: {},
            user: {},
            book_accessions: [],
            index: 0,
            stats:{
              not_returned_book_count:0,
                lost_book_count:0,
            },
        }
    }, methods: {
        getNames() {
            bookService.getNames().then(response => {
                this.names = response.data.names
            })
        },
        getSetting() {
            siteSetting.show().then(response => {
                this.setting = response.data
            })
        },
        getLibrarySetting() {
            setting.first().then(response => {
                if (response.data)
                    this.library_setting = response.data
            })
        },
        validateBookBarCode(barcode) {
            bookService.validateBookBarCode(barcode).then(response => {
                this.exist = response.data
            })
        },
        getBook(bookId) {
            this.isBusy = true;
            bookService.show(bookId).then(response => {
                this.book = response.data.book
                this.edit = true
                this.isBusy = false;
                // this.$refs['stock-history'].getStockHistory();
            })
        },
        getActiveBooks() {
            bookService.getActive().then(response => {
                this.active_books = response.data.books
            })
        },
        checkBookAvailability(userId, bookId) {
            if (this.setting.enable_accession_no) {

            } else {
                issueService.checkBookAvailability(userId, bookId).then(response => {
                    this.book_availability = response.data.availability
                    if (!this.book_availability.flag) {
                        this.$snotify.error(this.book_availability.msg)
                    } else {
                        this.getBook();
                    }
                })
            }
        },
        getBooks() {
            bookService.paginate(this.search, this.page).then(response => {
                this.books = response.data.data
                this.page = response.data.meta.current_page;
                this.total = response.data.meta.total;
                this.perPage = response.data.meta.per_page;
            })
        },
        deleteBook(id) {
            this.$confirm({
                message: `Are you sure?`,
                button: {
                    no: "No",
                    yes: "Yes"
                },
                callback: confirm => {
                    if (confirm) {
                        bookService.delete(id).then(response => {
                            this.$snotify.success("Book has been deleted successfully")
                            this.getBooks();
                        }).catch(error => {
                            this.$snotify.error("Something went wrong")
                        })
                    }
                }
            });
        },
        save(fd) {
            this.isBusy = true
            bookService.store(fd).then(response => {
                this.redirectTo(response.data.book.id)
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                this.isBusy = false
            })
        },
        update(bookId, fd) {
            this.isBusy = true
            bookService.update(bookId, fd).then(response => {
                this.$tabs.close().then(() => {
                    this.redirectTo()
                })
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                this.isBusy = false
            })
        },

        updateByBarcodeNo(barcodeNo, data) {
            if (this.index != 0)
                return
            this.isBusy = true
            this.index = 1
            bookService.updateByBarcodeNo(barcodeNo, data).then(response => {
                this.index = 0
                this.redirectTo(response.data.book.id)
            }).catch(error => {
                this.index = 0
                console.log(error)
            }).finally(() => {
                this.isBusy = false
            })
        },
        getShelves() {
            shelfService.getAllActive().then(response => {
                this.shelves = response.data.data
                if (this.book.shelf_id) {
                    this.getRack()
                }
            })
        },
        getRack() {
            rackService.getByShelf(this.book.shelf_id).then(response => {
                this.racks = response.data.data
            })
        },

        generateFd() {
            let fd = new FormData();
            for (let key in this.book) {
                if (key == "is_active" && this.book["is_active"]) {
                    fd.append("is_active", this.book["is_active"] ? 1 : 0);
                } else if (key == "in_stock" && this.book["in_stock"]) {
                    fd.append("in_stock", this.book["in_stock"] ? 1 : 0);
                } else if (key == "qty_on_hand" && this.book["qty_on_hand"]) {
                    fd.append("qty_on_hand", this.book["qty_on_hand"] ? 1 : 0);
                } else if (key == "available_for_all") {
                    fd.append("available_for_all", this.book["available_for_all"] ? 1 : 0);
                } else {
                    fd.append(key, this.book[key]);
                }
            }
            if (this.manage_inventory) {
                fd.append('inventory', JSON.stringify(this.inventory))
            }
            // if (!this.shelf_id)
            //     fd.delete('shelf_id')
            // if (!this.rack_id)
            //     fd.delete('rack_id')
            return fd;
        },

        getClassifications() {
            classService.getAllActive().then(response => {
                this.classifications = response.data.data
                // alert(this.book.parent_classification_id)
                // alert(this.book.parent_classification_title)
                if (this.book.parent_classification_id) {
                    let obj = this.classifications.find(ele => ele.id === this.book.parent_classification_id)
                    this.book.parent_classification = obj
                    this.getChildClassification()
                }
            })
        },
        getChildClassification() {
            classService.getAllChildren(this.book.parent_classification.id).then(response => {
                this.child_classifications = response.data.data
            })
        },

        returnBook(issue) {
            this.$confirm({
                message: `Are you sure?`,
                button: {
                    no: "No",
                    yes: "Yes"
                },
                callback: confirm => {
                    if (confirm) {
                        this.issue.status = "returned";
                        issueService.update(issue.id, issue).then(response => {
                            this.$snotify.success("Book returned successfully")
                            this.closeDialog()
                        })
                    }
                }
            })

        },
        renewBook(issue) {
            this.$confirm({
                message: `Are you sure?`,
                button: {
                    no: "No",
                    yes: "Yes"
                },
                callback: confirm => {
                    if (confirm) {
                        issueService.update(issue.id, issue).then(response => {
                            this.$snotify.success("Book renewed successfully")
                            this.closeDialog()
                        })
                    }
                }
            })
        },
        searchBookAccession(bookId, accessionNo) {
            if (accessionNo) {
                accession.searchAccessionNo(bookId, accessionNo).then(response => {
                    this.accessions = response.data
                })
            }
        },
        toggleAvailability(bookId, accessionId) {
            if (accessionId) {
                accession.toggleAvailability(bookId, accessionId).then(response => {
                    this.searchBookAccession(this.book.id, this.accession_no)
                    this.$snotify.success("Request completed")
                })
            }
        },

        searchBook(key) {
            this.loading = true
            bookService.searchBook(key).then(response => {
                this.loading = false
                this.active_books = response.data.books;
            }).catch(error => {
                this.loading = false
            })
        },
       /* searchUser(data) {
            this.loading = true;
            this.users = [];
            user
                .paginate(data)
                .then(response => {

                this.users = [];
                let users=[];
                 users = response.data.data;
                if(users.length > 0 ){
                    users.map(ele => {

                        // if (ele.user_symbol_no && ele.user_symbol_no != undefined && ele.user_symbol_no != null) {
                        ele.display_text = `${ele.id_card_no ? ele.id_card_no + '-' : ''} ${ele.personal_id.toUpperCase()} - ${ele.full_name} - ${ele.email}`;

                        this.users.push(ele)
                        // }
                    });
                }else{
                    this.users=[];
                }


                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },*/
        getUserById(userId) {
            user.show(userId).then(response => {
                this.user = response.data.user
            })
        },

        issuedBook(userId, type) {
            issueService.issuedBook(userId, type).then(response => {
                this.user_issue_list = response.data.books
            })
        },

        searchBookByAccession(accessionNo) {
            this.loading = true
            this.book_accessions = [];
            if (accessionNo.length <= 3)
                return
            accession.searchByAccessionNo(accessionNo).then(response => {
                this.book_accessions = response.data.book

            }).catch(error => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        getBookStats(){

            bookService
                .bookStats()
                .then(response => {
                    this.stats.not_returned_book_count=response.data.not_returned_book_count;
                    this.stats.lost_book_count=response.data.lost_book_count;
                })
                .catch(error => {

                }).finally(() => {

                })
        }


    }
}
